import { Button } from '@material-ui/core';
import React, { ReactElement, ReactNode, MouseEvent } from 'react';

import './link-button.styles.scss';

export interface ILinkButtonProps {
	className?: string;
	children?: ReactNode;
	onClick?: (event?: MouseEvent<HTMLButtonElement>) => void;
}

export function LinkButton(props: ILinkButtonProps): ReactElement {
	const { className, onClick, children } = props;
	return (
		<Button
			className={`link-button ${className || ''}`}
			color="primary"
			onClick={onClick}
		>
			{children}
		</Button>
	);
}
